import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setCountTransport } from '../redux/wishlist/actions'
import { getUserDetailsModel } from '../redux/user/selectors'
import CookieManagerService from '../services/cookie-manager-service'
import RootState from '../redux/types'

export const useSetWishlistCount = () => {
    const dispatch = useDispatch()
    const userDetails = useSelector(getUserDetailsModel)
    const isLoggedIn = !!userDetails?.id

    useEffect(() => {
        let count
        if (isLoggedIn && userDetails?.favoriteCount) {
            count = userDetails?.favoriteCount
        }
        if (!isLoggedIn && CookieManagerService.getCookie(CookieManagerService.FAVORITE_LISTINGS_IDS)) {
            count = CookieManagerService.getCookie(CookieManagerService.FAVORITE_LISTINGS_IDS)?.split(',').length
        }
        dispatch(setCountTransport(count))
    }, [isLoggedIn, userDetails?.favoriteCount, dispatch])
}

export const useWishlistCount = (): number => {
    const userDetails = useSelector(getUserDetailsModel)
    const reduxWishlistCount = useSelector((state: RootState) => state.wishlist.count)
    return reduxWishlistCount ?? userDetails?.favoriteCount ?? 0
}
